module.exports = __webpack_public_path__ + "media/images/kid/kid_avatar_06-acb91fd41698cd7949beb70fbf886a82.png";